import {formatStatsAndType} from "./FormatStatsAndType";

export const liveScoresMeta = {
    tr: {
        title: 'XFStats - Futbol Canlı Sonuçlar | İddaa Sonuçları | Canlı Bahis | XFStats.com',
        description: 'İddaa, canlı maç sonuçları, iddaa canlı skor, iddaa maç skorları, iddaa programı sonucları.',
        canonical: 'https://www.xfstats.com/',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'iddaa, Futbol, Tahmin, Maçlar, Spor, Sahadan, Canlı Sonuçlar, Basketbol, Fenerbahçe, Galatasaray, Beşiktaş, Trabzonspor, Superlig, Transfer, Transferler'
            }
        }
    },
    en: {
        title: 'XFStats - Football Live Scores, Latest Football Results | XFStats.com',
        description: 'Football live scores page on XFStats.com offers all the latest football results from more than 2200+ football leagues all around the world including EPL, LaLiga, Serie A, Bundesliga, UEFA Champions League and more.',
        canonical: 'https://www.xfstats.com/',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'Football, livescore, live scores, results'
            }
        }
    }
}

export const statsMeta = {
    tr: {
        title: 'XFStats - Football Stats, Tables & Results | Soccer Stats | Live Scores',
        description: 'XFStats - İstatistikler hakkında tüm bilgi Descriptions',
        canonical: 'https://www.xfstats.com/stats',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'react,meta,document,html,tags'
            }
        }
    },
    en: {
        title: 'XFStats - Football Stats, Tables & Results | Soccer Stats | Live Scores',
        description: 'XFStats - All information about statistics Descriptions',
        canonical: 'https://www.xfstats.com/stats',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'react,meta,document,html,tags'
            }
        }
    }
}

export const bestTeamsMeta = (stats, type) => {
    return {
        tr: {
            title: `XFStats - ${formatStatsAndType(stats)} - ${formatStatsAndType(type)} En iyi takımlar hakkında tüm bilgi`,
            description: 'XFStats - En iyi takımlar hakkında tüm bilgi Descriptions',
            canonical: 'https://www.xfstats.com/best-teams',
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                }
            }
        },
        en: {
            title: `XFStats - ${formatStatsAndType(stats)} - ${formatStatsAndType(type)} All information about best teams`,
            description: 'XFStats - All information about best teams Descriptions',
            canonical: 'https://www.xfstats.com/best-teams',
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                }
            }
        }
    }
}

export const trendMatchesMeta = (stats, type) => {
    return {
        tr: {
            title: `XFStats - ${formatStatsAndType(stats)} - ${formatStatsAndType(type)} Trend Maçlar hakkında tüm bilgi`,
            description: 'XFStats - Trend Maçlar hakkında tüm bilgi Descriptions',
            canonical: 'https://www.xfstats.com/trend-matches',
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                }
            }
        },
        en: {
            title: `XFStats - ${formatStatsAndType(stats)} - ${formatStatsAndType(type)} All information about trend Matches`,
            description: 'XFStats - All information about trend Matches Descriptions',
            canonical: 'https://www.xfstats.com/trend-matches',
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                }
            }
        }
    }
}

export const scoreRadarMeta = {
    tr: {
        title: 'XFStats - Football Stats, Tables & Results | Soccer Stats | Live Scores',
        description: 'XFStats - SkorRadar hakkında tüm bilgi Descriptions',
        canonical: 'https://www.xfstats.com/scoreradar',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'react,meta,document,html,tags'
            }
        }
    },
    en: {
        title: 'XFStats - Football Stats, Tables & Results | Soccer Stats | Live Scores',
        description: 'XFStats - All information about ScoreRadar Descriptions',
        canonical: 'https://www.xfstats.com/scoreradar',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'react,meta,document,html,tags'
            }
        }
    }
}

export const tvGuideMeta = {
    tr: {
        title: 'XFStats - Football Stats, Tables & Results | Soccer Stats | Live Scores',
        description: 'XFStats - Maç TV ekranları Descriptions',
        canonical: 'https://www.xfstats.com/tv',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'react,meta,document,html,tags'
            }
        }
    },
    en: {
        title: 'XFStats - Football Stats, Tables & Results | Soccer Stats | Live Scores',
        description: 'XFStats - Match TV screens Descriptions',
        canonical: 'https://www.xfstats.com/tv',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'react,meta,document,html,tags'
            }
        }
    }
}

export const teamDetailsMeta = (teamName, teamId) => {
    return {
        tr: {
            title: `XFStats - ${teamName} hakkında tüm bilgi`,
            description: `XFStats - ${teamName} hakkında tüm bilgi Descriptions`,
            canonical: `https://www.xfstats.com/team-detail/${teamId}`,
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                }
            }
        },
        en: {
            title: `XFStats - All information about ${teamName}`,
            description: `XFStats - All information about ${teamName} Descriptions`,
            canonical: `https://www.xfstats.com/team-detail/${teamId}`,
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                }
            }
        }
    }
}

export const matchDetailsMeta = (matchDetail) => {
    return {
        tr: {
            title: `XFStats - ${matchDetail?.home} - ${matchDetail?.away} maçı detayları`,
            description: `XFStats - ${matchDetail?.home} - ${matchDetail?.away} maçı detayları Descriptions`,
            canonical: `https://www.xfstats.com/match-detail/${matchDetail?.id}`,
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                }
            }
        },
        en: {
            title: `XFStats - ${matchDetail?.home} - ${matchDetail?.away} match details`,
            description: `XFStats - ${matchDetail?.home} - ${matchDetail?.away} match details Descriptions`,
            canonical: `https://www.xfstats.com/match-detail/${matchDetail?.id}`,
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                }
            }
        }
    }
}

export const leagueDetailsMeta = (league) => {
    return {
        tr: {
            title: `XFStats - ${league?.league} hakkında tüm bilgi`,
            description: `XFStats - ${league?.league} hakkında tüm bilgi Descriptions`,
            canonical: `https://www.xfstats.com/league-details/${league?.seasonId}/${league.leagueId}`,
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                }
            }
        },
        en: {
            title: `XFStats - All information about ${league?.league}`,
            description: `XFStats - All information about ${league?.league} Descriptions`,
            canonical: `https://www.xfstats.com/league-details/${league?.seasonId}/${league.leagueId}`,
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: 'react,meta,document,html,tags'
                }
            }
        }
    }
}
